import { HashRouter as Router, Switch, Route } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import ScrollToTop from "react-router-scroll-top";

import "react-toastify/dist/ReactToastify.css";
import * as ROUTES from "./constans/rutas";
import AlertaState from "./context/alertas/alertaState";
import AuthState from "./context/autenticacion/authState";
import tokenAuth from "./config/tokenAuth";
import Desenganche from "./paginas/Desenganche/home";
import Mensualidades from "./paginas/Mensualidades";
import Convenios from "./paginas/Codigos";
import Juridicas from "./paginas/Juridicas";
import BManual from "./paginas/BManual";
import SupportDoc from "./paginas/SupportDoc";

import HomePage from "./paginas";
import RutaPrivada from "./components/rutas/RutaPrivada";
import LoginPage from "./paginas/auth/login";
import RegistroPage from "./paginas/auth/registro";
import EthicsChannel from "./paginas/EthicsChannel";
import ConsultInvoice from "./paginas/pdf";
import CreditNotes from "./paginas/CreditNotes";

const token = localStorage.getItem("token");
if (token) {
  tokenAuth(token);
}

function App() {
  return (
    <>
      <AlertaState>
        <Router>
          <ScrollToTop>
            <AuthState>
              <div className="top-header" />
              <Switch>
                <Route exact path={ROUTES.LOGIN} component={LoginPage} />
                <RutaPrivada
                  exact
                  path={ROUTES.REGISTRO}
                  component={RegistroPage}
                />
                <RutaPrivada exact path={ROUTES.HOME} component={HomePage} />
                <RutaPrivada
                  exact
                  path={ROUTES.DESENGANCHE}
                  component={Desenganche}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.MENSUALIDADES}
                  component={Mensualidades}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.CONVENIOS}
                  component={Convenios}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.JURIDICAS}
                  component={Juridicas}
                />
                <RutaPrivada exact path={ROUTES.BMANUAL} component={BManual} />
                <RutaPrivada
                  exact
                  path={ROUTES.SUPPORTDOC}
                  component={SupportDoc}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.ETHICSCHANNEL}
                  component={EthicsChannel}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PDF}
                  component={ConsultInvoice}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.CREDITNOTES}
                  component={CreditNotes}
                />
              </Switch>
            </AuthState>
          </ScrollToTop>
        </Router>
        <ToastContainer />
      </AlertaState>
    </>
  );
}

export default App;
